import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { useMemo } from 'react';

import { RecommendationVisibilityWrapper } from '@/pages/Item/ItemPage/components/ItemPageCarousel/RecommendationVisibilityWrapper';
import { ChairishItem } from '@/redux/modules/chairishSimilarItems/chairishSimilarItems.types';
import { LotRecommendationType } from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { ChairishItemCard } from './ChairishItemCard';
import { ChairishLogo } from './ChairishLogo';

type ChairishCarouselProps = {
    items: ChairishItem[];
};

export const ChairishCarousel = ({ items }: ChairishCarouselProps) => {
    const formatMessage = useAppFormatMessage();

    const carouselCards = useMemo(
        () =>
            items.map((item, index) => ({
                card: (
                    <ChairishItemCard
                        item={item}
                        key={item.lotId}
                        position={index}
                    />
                ),
                key: item.lotId,
            })),
        [items]
    );

    const recommendationIds = useMemo(() => items.map((item) => Number(item.lotId) || 0), [items]);

    if (items.length === 0) {
        return null;
    }

    return (
        <RecommendationVisibilityWrapper
            recommendationIds={recommendationIds}
            recommendationType={LotRecommendationType.AvailableOnChairish}
        >
            {/* Chairish brand cream (#fdeedf) — no semantic token exists for partner brand colors */}
            <div className="flex flex-col items-center gap-md rounded-container bg-[#fdeedf] p-10 smMax:gap-sm smMax:rounded-none smMax:px-sm smMax:py-md">
                <div className="flex flex-col items-center gap-2xs text-center">
                    <h2 className="flex items-center gap-xs hui-text-h1">
                        {formatMessage(['searchPage', 'zeroResults', 'chairish', 'title'])}
                        <ChairishLogo />
                    </h2>
                    <BodyPrimary className="text-text-secondary">
                        {formatMessage(['searchPage', 'zeroResults', 'chairish', 'subtitle'])}
                    </BodyPrimary>
                </div>
                <Carousel
                    cards={carouselCards}
                    useOverlayControls
                    showPagination
                    selectedPage={1}
                />
            </div>
        </RecommendationVisibilityWrapper>
    );
};
